import {
  SoftwareManagementApplicationDetailsPageQueryDocument,
  SoftwareManagementCreateSoftwarePaymentDocument,
  SoftwareManagementCreateSoftwarePaymentMutation,
  SoftwareManagementCreateSoftwarePaymentMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateSoftwarePayment = () => {
  const [createSoftwarePayment, { loading }] = useMutation(
    SoftwareManagementCreateSoftwarePaymentDocument,
    {
      extractorFn: (data: SoftwareManagementCreateSoftwarePaymentMutation) =>
        data.softwareManagementMutations.createSoftwaremanagementSoftwarePayment,
    }
  )

  return {
    create(
      variables: SoftwareManagementCreateSoftwarePaymentMutationVariables,
      currency: string,
      companyId: string
    ) {
      return createSoftwarePayment({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: SoftwareManagementApplicationDetailsPageQueryDocument,
            variables: {
              softwareSetupId: variables.softwareSetupId,
              currency,
              companyId: companyId,
            },
          },
        ],
      })
    },
    loading,
  }
}
